var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPay4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 18,
    viewBox: "94 40 80 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.424 54.7249V47.801H107.577V45.2812H96.25V47.801H100.401V54.7249H103.424ZM111.809 45.2812H108.786V54.7249H111.809V45.2812ZM114.022 45.2812V54.7249H116.8V49.5068L121.987 54.7249H124.559V45.2812H121.784V50.4597L116.721 45.2812H114.022ZM130.506 51.1539L133.988 54.7249H137.884L133.024 49.8043L137.699 45.2812H134.032L130.506 48.8324H129.702V45.2812H126.777V54.7249H129.702V51.1539H130.506ZM143.893 45.0225C139.961 45.0225 137.611 47.2051 137.611 50.0225C137.611 52.8407 139.961 55.0225 143.893 55.0225C147.808 55.0225 150.159 52.8407 150.159 50.0225C150.159 47.2051 147.808 45.0225 143.893 45.0225ZM143.893 52.7208C141.941 52.7208 140.686 51.5704 140.686 50.0225C140.686 48.4754 141.941 47.344 143.893 47.344C145.829 47.344 147.101 48.4754 147.101 50.0225C147.101 51.5704 145.829 52.7208 143.893 52.7208ZM161.248 45.2812H151.555V54.7249H154.471V51.4316H160.824V49.3481H154.471V47.682H161.248V45.2812ZM172.25 45.2812H162.556V54.7249H165.472V51.4316H171.826V49.3481H165.472V47.682H172.25V45.2812Z",
    fill: "#2C3038"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPay4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pay4.ad3697d4268c70ff6a9e295c8d6b581c.svg";